<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
  ::v-deep.el-card__header {
    // padding: 16px 20px 0 24px;
    border-bottom: none;
    div {
      .title {
        font-size: 14px;
        color: #111111;
        font-weight: 600;
      }
      .btns {
        float: right;
      }
    }
  }
}
.el-alert--warning {
  &.is-light {
    border: 1px solid #ccecff;
    color: #262626;

    ::v-deep.el-alert__icon {
      color: #1b9aee;
    }
  }
}
.smallCard {
  // margin-bottom:20px;
  ::v-deep.el-card__header {
    padding: 0px 20px;
    border-bottom: 1px solid #f0f0f0;
    div {
      .title {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
      }
      .btns {
        float: right;
      }
    }
  }
  ::v-deep.el-card__body {
    padding: 12px;
  }
}
</style>
<template>
  <div>
    <el-card
      class="box-card"
      shadow="never"
    >
      <div v-if="info">
        <el-alert
          :title="info"
          type="warning"
          show-icon
          :closable="false"
        />
      </div>
      <div
        v-if="title"
        slot="header"
        class="clearfix"
      >
        <span class="title">{{ title }}</span>
        <div
          v-if="btns"
          class="btns"
        >
          <el-button
            v-for="item in btns"
            :key="item.key"
            :type="item.type"
            :plain="item.type === 'text' ? false : true"
            size="small"
            @click="btnFun(item.key)"
          >
            {{ item.name }}
          </el-button>
        </div>
      </div>
      <div v-else>
        <slot name="header" />
      </div>
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SpCardContent',
  props: {
    title: {
      type: String
    },
    btns: {
      type: Array
    },
    info: {
      type: String
    }
  },
  data () {
    return {}
  },
  watch: {},
  mounted () {
    // console.log(this.title)
  },
  methods: {
    btnFun (key) {
      this.$emit('btnsOption', key)
    }
  }
}
</script>
